const PUBLIC = process.env.PUBLIC_URL || "";

export const APP_CONFIG = {
    BASE_API: process.env.REACT_APP_PORT_URL || process.env.REACT_APP_WEB_URL,
    ASSET_BASE: process.env.REACT_APP_COURSES_LOGO || "",

  DASHBOARD_VIDEO: `${PUBLIC}/assets/videos/course-video.mp4`,
  NEXTESTIFY_VIDEO: `${PUBLIC}/assets/videos/nextestify.mp4`,
};
